(() => {
  const scopes = new Map()
  const scopeSelector = '.product-single__meta'
  const promoSelector = '[id^="tp-promo-display-"]'

  function text(root, selector) {
    return root.querySelector(selector)?.textContent.trim() || ''
  }

  function element(className, value = '') {
    const node = document.createElement('div')
    node.className = className
    node.textContent = value
    return node
  }

  function renderPrices(node, original, current, note = '') {
    const signature = JSON.stringify([original, current, note])
    if (node.dataset.priceSignature === signature) return
    node.dataset.priceSignature = signature
    const row = element('tp-purchase-price__row')
    if (original && original !== current) {
      const previous = document.createElement('s')
      previous.textContent = original
      row.append(previous)
    }
    const amount = document.createElement('span')
    amount.textContent = current
    row.append(amount)
    node.replaceChildren(row)
    if (note) node.append(element('tp-purchase-price__note', note))
  }

  function update(scope) {
    const promo = scope.querySelector(promoSelector)
    const widget = scope.querySelector('.appstle_sub_widget')
    if (!promo) return
    if (!widget) {
      const content = promo.querySelector('.tp-promo-display__content')
      if (content) content.hidden = false
      promo.querySelector('.tp-purchase-price__label')?.remove()
      promo.querySelector('.tp-purchase-price__subscription')?.remove()
      return
    }

    widget.querySelectorAll('.appstle_tooltip_wrapper_static').forEach(details => {
      if (!/Initial discount is [\d.,]+%\s+and then\s*$/.test(details.textContent)) return
      details.childNodes.forEach(node => {
        if (node.nodeType !== Node.TEXT_NODE) return
        const value = node.nodeValue.replace(/(Initial discount is [\d.,]+%)\s+and then\s*$/, '$1')
        if (value !== node.nodeValue) node.nodeValue = value
      })
    })

    const content = promo.querySelector('.tp-promo-display__content')
    const selected = widget.querySelector('input[name="selling_plan"]:checked')
    const option = selected?.closest('.appstle_subscription_wrapper_option')
    const subscribed = Boolean(selected?.value)
    const subscriptionPrice = subscribed ? text(option, '.appstle_subscription_amount') : ''
    let label = promo.querySelector('.tp-purchase-price__label')
    let subscription = promo.querySelector('.tp-purchase-price__subscription')

    if (!label) {
      label = element('tp-purchase-price__label')
      promo.prepend(label)
    }
    if (!subscription) {
      subscription = element('tp-purchase-price__subscription')
      subscription.hidden = true
      subscription.setAttribute('aria-live', 'polite')
      promo.append(subscription)
    }

    const labelText = subscribed
      ? text(option, '.appstle_subscribe_save_text')
      : text(widget, '.appstle_one_time_text')
    if (label.textContent !== labelText) label.textContent = labelText
    label.hidden = !labelText
    if (content) content.hidden = subscribed
    subscription.hidden = !(subscribed && subscriptionPrice)
    if (!subscription.hidden) {
      renderPrices(subscription, text(option, '.appstle_subscription_compare_amount'), subscriptionPrice)
    }

    const oneTimeWrapper = widget.querySelector('.appstle_one_time_price_wrapper')
    if (!oneTimeWrapper) return
    const salePrice = text(promo, '.tp-promo-display__sale-price')
    const originalPrice = text(promo, '.tp-promo-display__original-price')
    const basePrice = text(oneTimeWrapper, ':scope > .appstle_subscription_amount')
    const canMirror = Boolean(salePrice && originalPrice && originalPrice === basePrice)
    let oneTimePrice = oneTimeWrapper.querySelector('.tp-purchase-price__one-time')
    oneTimeWrapper.classList.toggle('tp-purchase-price--promotional', canMirror)
    if (!canMirror) {
      oneTimePrice?.remove()
      return
    }
    if (!oneTimePrice) {
      oneTimePrice = element('tp-purchase-price__one-time')
      oneTimeWrapper.append(oneTimePrice)
    }
    const notes = Array.from(promo.querySelectorAll('.tp-promo-display__content > .tp-promo-display__note'))
      .map(node => node.textContent.trim()).filter(Boolean).join(' ')
    renderPrices(oneTimePrice, originalPrice, salePrice, notes)
  }

  function connect(scope) {
    if (scopes.has(scope) || !scope.querySelector(promoSelector) || !scope.querySelector('.appstle_sub_widget')) return
    let pending = false
    const observer = new MutationObserver(schedule)
    const options = { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['class', 'value', 'checked'] }
    function refresh() {
      pending = false
      if (!scope.isConnected) return
      observer.disconnect()
      update(scope)
      observer.observe(scope, options)
    }
    function schedule() {
      if (pending) return
      pending = true
      requestAnimationFrame(refresh)
    }
    scope.addEventListener('change', schedule)
    scopes.set(scope, { observer, schedule })
    refresh()
  }

  function discover(node) {
    if (!(node instanceof Element)) return
    if (node.matches(scopeSelector)) connect(node)
    if (node.matches(`${promoSelector}, .appstle_sub_widget`)) {
      const scope = node.closest(scopeSelector)
      if (scope) connect(scope)
    }
    node.querySelectorAll(`${scopeSelector}, ${promoSelector}, .appstle_sub_widget`).forEach(child => {
      const scope = child.matches(scopeSelector) ? child : child.closest(scopeSelector)
      if (scope) connect(scope)
    })
  }

  discover(document.body)
  new MutationObserver(records => {
    for (const [scope, state] of scopes) {
      if (scope.isConnected) continue
      state.observer.disconnect()
      scope.removeEventListener('change', state.schedule)
      scopes.delete(scope)
    }
    for (const record of records) record.addedNodes.forEach(discover)
  }).observe(document.body, { childList: true, subtree: true })
})()
